<template>
  <v-container>
    <v-form ref="form" v-model="form_valid" lazy-validation >
      <div v-if="!entry.entry_type_id && !this.$route.params.id" >
        <center>
          <div>
            <v-btn class="button" @click = "MainSelection($event,'Have_Fill')" large>
                <center>
                  <v-icon color = "red">mdi-alpha-f-circle</v-icon>
                  <div class="break">
                    <span>Fill Available</span>
                  </div>
                </center>
            </v-btn>
            <v-btn  class="button" @click = "MainSelection($event,'Need_Fill')" large>
              <center>
                <v-icon color="blue">mdi-alpha-f-circle</v-icon>
                <div class="break">
                  <span>Fill Needed</span>
                </div>
              </center>
            </v-btn>
          </div>
            <v-btn   class="button" @click = "MainSelection($event,'Have_Topsoil')" large>
              <center>
              <v-icon color = "green">mdi-alpha-t-circle</v-icon>
                <div class="break">
                  <span>Topsoil Available</span>
                </div>
              </center>
            </v-btn>
            <v-btn  class="button" @click = "MainSelection($event,'Need_Topsoil')" large>
              <center>
                <v-icon color = "purple">mdi-alpha-t-circle</v-icon>
                <div class="break">
                  <span>Topsoil Needed</span>
                </div>
              </center>
            </v-btn>
        </center>
      </div>
      <div v-if="entry.entry_type_id" class="form">
        <h3 id="span">{{entry_type_name}}</h3>
        <v-text-field  label="Loads" type="number" v-model.number="entry.loads" :rules="loads_rules" />
        <v-text-field v-if="entry.entry_type_id=='Have_Fill' || entry.entry_type_id == 'Have_Topsoil'" label="Price per load" type="number" prefix="$" v-model.number="entry.price" :rules="cost_rules" />
        <v-autocomplete v-if="entry.entry_type_id=='Have_Fill' || entry.entry_type_id == 'Need_Fill'" label="Soil types" v-model="entry.soil_type_id" :items="soil_types" item-value="id" item-text="Name" :rules="required_field_rules" />
        <v-btn v-if="!entry.coords && !this.$route.params.id" class="mr-3" @click="get_location"><v-icon>mdi-crosshairs-gps</v-icon><span>Use my location</span></v-btn>
        <v-text-field v-if="!used_location"  label="Street Address" v-model.trim="entry.street_address" :counter="50" :rules="street_rules" />
        <v-text-field v-if="!used_location" label="City" v-model.trim="entry.city" :counter="20" :rules="city_rules" />
        <v-autocomplete v-if="!used_location" label="State" v-model="entry.state" :items="states" item-value="id" item-text="Name" :rules="required_field_rules" />
        <v-text-field v-if="!used_location" label="Zip" type="number" v-model.trim="entry.zip" :counter="5" :rules="zip_rules" />
        <v-text-field  label="Name" v-model.trim="entry.name" :counter="40" :rules="name_rules" />
        <v-text-field  label="Phone Number" type="number" v-model.trim="entry.phone" :counter="10" :rules="phone_rules" />
        <v-textarea label="Other Information" v-model.trim="entry.comments" :counter="500" :rules="comments_rules" />
        <v-btn color="primary" class="mr-3 mb-12" @click="save_entry">Save</v-btn>
        <v-btn v-if="this.$route.params.id" color="error" class="mr-3 mb-12" @click="delete_entry">Delete</v-btn>
      </div>
      <v-snackbar :color="snackbar.color" v-model="snackbar.show" :timeout="3000" >
        {{ snackbar.message }}
        <v-btn text @click="snackbar.show = false">Close</v-btn>
      </v-snackbar>
    </v-form>
  </v-container>
</template>

<script>
import {firebase, db} from '@/firebaseInit.js'
import browserDetect from '@/util/browser-detect.js'
export default {
  name: 'entry',
  data: () => ({
    choice: null,
    entry_types: [],
    soil_types: [],
    states: [],
    used_location: false,
    entry: {
      loads: '',
      entry_type_id: '',
      street_address: '',
      city: '',
      state: 'PA',
      zip: '',
      price: '',
      name: '',
      phone: '',
      soil_type_id: '',
      comments: '',
    },
    form_valid: true,
    snackbar: {
      show: false,
      message: null,
      color: "primary"
    },
    required_field_rules: [
      v => !!v || 'Required',
    ],
    text_rules: [
      v => !!v || 'Required',
      v => (!v || v.length <= 500) || 'Must be 500 characters or less',
    ],
    cost_rules: [
      v => v !== '' || 'Required',
      v => (v >= 0 && v < 100000) || 'Must be between 0 and 99999',
    ],
    street_rules: [
      v => !!v || 'Required',
      v => (!v || v.length <= 50) || 'Must be 50 characters or less',
    ],
    city_rules: [
      v => !!v || 'Required',
      v => (!v || v.length <= 20) || 'Must be 20 characters or less',
    ],
    zip_rules: [
      v => !!v || 'Required',
      v => (!v || v.length <= 5) || 'Must be 5 characters or less',
    ],
    loads_rules: [
      v => !!v || 'Required',
      v => (v > 0 && v < 100000) || 'Must be between 0 and 99999',
    ],
    name_rules: [
      v => !!v || 'Required',
      v => (!v || v.length <= 40) || 'Must be 30 characters or less',
    ],
    phone_rules: [
      v => !!v || 'Required',
      v => (!v || v.length <= 10) || 'Must be 10 characters or less',
    ],
    comments_rules: [
      v => (!v || v.length <= 500) || 'Must be 500 characters or less',
    ],
  }),
  computed: {
    entry_type_name: function() {
      return this.entry_types.find(c => c.id == this.entry.entry_type_id).Name
    }
  },
  async created() {
    if (this.$route.params.id) {
      let entryRef = db.collection("entry").doc(this.$route.params.id);
      entryRef.get().then(doc => {
        if (doc.exists) {
          // only copy the properties that actually exist in our entry form, 
          // so that we don't later overwrite extra fields (e.g. coords) that the server has computed
          let serverData = doc.data();
          for (const key of Object.keys(this.entry)) {
            this.entry[key] = serverData[key];
          }
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      }).catch(function(error) {
        console.log("Error getting document:", error);
      })
    }
    else {
      var user = await firebase.getCurrentUser();
      if (!user) return;

      let profile = await db.collection("user_profiles").doc(user.uid).get();
      if (!profile.exists) return;

      this.entry.phone = profile.data().Phone
      this.entry.name = profile.data().Name
    }
  },
  
  firestore: {
    entry_types: db.collection('entry_types'),
    states: db.collection('states'),
    soil_types: db.collection('soil_types')
  },  
  methods: {
    get_location() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          let latitude = position.coords.latitude;
          let longitude = position.coords.longitude;
          this.entry.coords = new firebase.firestore.GeoPoint(latitude, longitude)
          this.used_location = true
          this.snackbar.show = true;
          this.snackbar.message = "Location Successful";
          this.snackbar.color = "primary";
          this.entry.street_address = "pending"
        });
      } else {
        this.errorSnackbar("Geolocation is not supported by this browser.");
      }
    },

    MainSelection(event,ButtonType) {
      this.entry.entry_type_id = ButtonType
    },
    async delete_entry() {
      await db.collection("entry").doc(this.$route.params.id).delete();
      this.$router.push('/listings');
    },
    errorSnackbar(message) {
        this.snackbar.show = true;
        this.snackbar.message = message;
        this.snackbar.color = "error";
    },
    save_entry() {
      if (!this.$refs.form.validate()) {
        this.errorSnackbar("One or more items are not valid. Scroll back up and check for red messages.");
        return;
      } 
    
      const restore_entry = {...this.entry};
      const entry_to_save = {
        ...this.entry,
        entry_type_name: this.entry_type_name,
        modified_date: firebase.firestore.FieldValue.serverTimestamp(),
      };
      if (this.entry.entry_type_id == "Have_Fill" || this.entry.entry_type_id == "Need_Fill"){
        entry_to_save.soil_type_name= this.soil_types.find(c => c.id == this.entry.soil_type_id).Name;
      }
      const current_user = firebase.auth().currentUser;
      if (current_user) {
        entry_to_save.user_id = current_user.uid;
        entry_to_save.user_email = current_user.email;
        entry_to_save.user_email_verified = current_user.emailVerified;
        entry_to_save.user_display_name = current_user.displayName;
      }
      let dbPromise = null;

      db.collection("user_profiles").doc(current_user.uid).set({
        Name: this.entry.name,
        Phone: this.entry.phone,
        app_version: this.$appConfig.app.version,
        modified_date: firebase.firestore.FieldValue.serverTimestamp(),
        ...browserDetect.getProperties(),
      })

      if (this.$route.params.id) {
        entry_to_save.reverse_geo = false;
        // firestore doesn't allow saving null fields
        if (!entry_to_save.comments) {
          entry_to_save.comments = firebase.firestore.FieldValue.delete();
        }
        dbPromise = db.collection("entry").doc(this.$route.params.id).set(entry_to_save, { merge: true })
      }
      else {
        // firestore doesn't allow saving null fields
        if (!entry_to_save.comments) {
          delete entry_to_save.comments;
        }
        dbPromise = db.collection("entry").add(entry_to_save)
        this.$analytics.logEvent("add_entry");
      }
      dbPromise.then( () => {
        //TODO: global indicator of sync status that gets cleared after server responds
      }).catch(error => {
        this.errorSnackbar(error);
        this.entry = restore_entry;
      });
      
      this.snackbar.show = true;
      this.snackbar.message = "Saved!";
      this.snackbar.color = "primary";
      this.$refs.form.reset()
      this.$router.push('/listings');
    },
  },
}
</script>
<style>
.break {
  flex-basis: 100%;
  height: 0;
}
.button {
  min-height: 100px;
  min-width: 100px;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: 5px;
  margin-left: 5px;
}
.form {
  margin-top:20px;
}
.button .v-icon {
  font-size: 50px;
}
.button span {
  min-width: 150px;
  min-height: 100px;
  font-size: 12px;
}
</style>